// extracted by mini-css-extract-plugin
module.exports = {"chip":"Chip_chip__OztxL","chip-artist":"Chip_chip-artist__fqEi_","chip-genre":"Chip_chip-genre__FKfWJ","chip-genre-hidden":"Chip_chip-genre-hidden__A0SV2"};